import Icon from "@mui/material/Icon";

import Dashboard from "layouts/dashboards/dashboard";
import UserManagement from "layouts/management/users";
import SubscriptionManagement from "layouts/management/subscriptions";
import ClientManagement from "layouts/management/clients";
import AdminManagement from "layouts/management/admins";
import KnowledgeBaseManagement from "layouts/management/knowledge-base";

const routes = [
  {
    type: "collapse",
    name: "Çerez Kütüphanesi",
    key: "knowledge-base",
    icon: <Icon fontSize="small">library_books</Icon>,
    route: "/knowledge-base",
    component: <KnowledgeBaseManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Kullanıcılar",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <UserManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Abonelikler",
    key: "subscriptions",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/subscriptions",
    component: <SubscriptionManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Müşteriler",
    key: "clients",
    icon: <Icon fontSize="small">language</Icon>,
    route: "/clients",
    component: <ClientManagement />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Adminler",
    key: "admins",
    icon: <Icon fontSize="small">verified_user</Icon>,
    route: "/admins",
    component: <AdminManagement />,
    noCollapse: true,
  }
];

export default routes;
